

import React from 'react'

const Help = () => {
  return (
    <div>Yardım</div>
  )
}

export default Help